import { getPrefillZipResult } from '../../shared/utils/zipCodeData';

/**
 * Submit-time validation for errors that the schema alone can't capture.
 * Returned objects match the jsonschema validator's error format.
 *
 * Unlike v1, there is no `view:claimType` check: v2 collects every claimed
 * condition through the conditions array-builder workflow.
 *
 * @param {Object} formData - current form data
 * @returns {Array} validation error objects
 */
export const getCustomValidationErrors = formData => {
  if (!formData) return [];

  const customErrors = [];

  // A prefilled mailing-address zip is never verified by ZipCodeInput (it only
  // fires on keystroke). onFormLoaded verifies it into a prefill-only store;
  // only block when that result is for the zip still in the form, otherwise
  // the live component validation owns the edited value.
  const prefillZip = getPrefillZipResult();
  const currentZip = formData.mailingAddress?.zipCode;
  if (
    prefillZip &&
    prefillZip.isValid === false &&
    currentZip &&
    String(currentZip).slice(0, 5) === prefillZip.zip
  ) {
    customErrors.push({
      property: 'instance.mailingAddress',
      message: 'requires property "zipCode"',
      name: 'required',
      argument: 'zipCode',
      stack: 'instance.mailingAddress requires property "zipCode"',
    });
  }

  if (
    !Array.isArray(formData.newDisabilities) ||
    formData.newDisabilities.length === 0
  ) {
    customErrors.push({
      property: 'instance.newDisabilities',
      message: 'does not meet minimum length of 1',
      name: 'minItems',
      argument: 1,
      stack: 'instance.newDisabilities does not meet minimum length of 1',
    });
  }

  return customErrors;
};

export default getCustomValidationErrors;
